import { initializeApp } from 'firebase/app';
import {
  initializeAuth, indexedDBLocalPersistence, browserLocalPersistence, browserSessionPersistence,
  browserPopupRedirectResolver, getRedirectResult,
  GoogleAuthProvider, sendSignInLinkToEmail, isSignInWithEmailLink, signInWithEmailLink,
  signInWithPopup as firebaseSignInWithPopup, signOut,
} from 'firebase/auth';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

const app = initializeApp(firebaseConfig);
// Same persistence order as getAuth(), so existing signed-in users stay signed in.
// The popup/redirect resolver is NOT attached here: attaching it makes Firebase load
// auth/iframe.js on page load on phones. It is attached only when sign-in is used.
export const auth = initializeAuth(app, {
  persistence: [indexedDBLocalPersistence, browserLocalPersistence, browserSessionPersistence],
});
export const googleProvider = new GoogleAuthProvider();

// Warm up the popup helper (loads auth/iframe.js) so the Google popup can open
// instantly from the click. Called when the sign-in modal opens.
let popupWarm = null;
export const prepareAuthPopup = () => {
  if (!popupWarm) popupWarm = getRedirectResult(auth, browserPopupRedirectResolver).catch(() => null);
  return popupWarm;
};

export const signInWithPopup = (authInstance, provider) =>
  firebaseSignInWithPopup(authInstance, provider, browserPopupRedirectResolver);

export {
  GoogleAuthProvider,
  sendSignInLinkToEmail,
  isSignInWithEmailLink,
  signInWithEmailLink,
  signOut,
};

export default app;
